// Paletas precargadas de "Jardín de Mariposas" (cumpleaños infantil femenino).
// "terciario" alimenta flores, hojas y acentos.
const FUENTES = {
  display: '"Gochi Hand", cursive',
  cuerpo: '"Quicksand", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "primavera",
    nombre: "Primavera",
    tema: {
      colores: {
        fondo: "#FFF8F3",
        fondoAlt: "#FDEEE6",
        texto: "#3D2A30",
        textoSuave: "#6E545C",
        textoTenue: "#A89096",
        primario: "#E26D8C",
        primarioSuave: "#FBDFE7",
        acento: "#F6B93B",
        terciario: "#7CB46C",
        borde: "rgba(61, 42, 48, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "lavandaDulce",
    nombre: "Lavanda dulce",
    tema: {
      colores: {
        fondo: "#F8F5FC",
        fondoAlt: "#EFE8F8",
        texto: "#33263F",
        textoSuave: "#5E4E6E",
        textoTenue: "#9A8BAC",
        primario: "#8A6BC9",
        primarioSuave: "#E8DFF6",
        acento: "#F6B93B",
        terciario: "#E26D8C",
        borde: "rgba(51, 38, 63, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "melon",
    nombre: "Melón",
    tema: {
      colores: {
        fondo: "#FFF6EE",
        fondoAlt: "#FDEBE0",
        texto: "#3B2718",
        textoSuave: "#6B5138",
        textoTenue: "#A68D76",
        primario: "#E8734A",
        primarioSuave: "#FBE2D5",
        acento: "#F6C445",
        terciario: "#6FB5A5",
        borde: "rgba(59, 39, 24, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
];
